export const availableLanguages = {
	en: "English",
	es: "Spanish",
}
